import { useLocation, useNavigate } from "react-router-dom"
import { FaUsers } from 'react-icons/fa';

export const Sidebar = () => {

    const navigate = useNavigate();
    const location = useLocation();

    return (
        <aside id="sidebar" className="sidebar">
            <ul className="sidebar-nav" id="sidebar-nav">
                <li className="nav-item">
                    <a className={`nav-link ${location.pathname == '/users' ? " active" : ""}`} onClick={(e) => navigate('/users?page=1')}>
                        <FaUsers />
                        <span>Users</span>
                    </a>
                </li>
            </ul>
        </aside>
    )

}